import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'
import getConfig from 'next/config'

import getSecretColor from '@libs/getSecretColor'
import { isSecretOrSexClas } from '@libs/postTools'

import { initialState } from '@app-core/post/reducer'
import { compose, getContext, withTranslation } from '@hocs'

import PopTime from './PopTime'
import PostImageBlock from './PostImageBlock'

import transformFactory from './TransformToNode'

import ArticleCard from '@components/ArticleCard'

import Sticky from 'react-stickynode'

import PostControlBox from './PostControlBox'
import './popapp-post-con.css'
import { withCleanPostData } from '@features/post/contexts/CleanPostDataContext'
import { TrackingSection } from '@features/post/contexts/TrackingSectionContext'
import { RecommendedArticlesContext } from '@features/post/contexts/RecommendedArticlesContext'
import RecommendedArticles from './RecommendedArticles'
import { PopularArticlesContext } from '@features/post/contexts/PopularArticlesContext'
import PopularArticlesContainer from './PopularArticles'

import { styled } from 'twin.macro'
import {
  ArticleLayout,
  Article,
  H1,
  StyledArticleContent,
  ArticleContentFooter,
  DownloadAppBannerContainer,
} from './WebPost.styled'
import { HASHTAG_CLASS_NAME } from '@features/editor/text-input/content-input/version-b/HashtagInlineTool'
import ArticleUserInfo from './ArticleUserInfo'
import ArticleAuthorInfo from './ArticleAuthorInfo'
import FixedRecommendedArticleCard from './FixedRecommendedArticleCard'
import ArticleTags from './ArticleTags'
import { MobileDisplayContainer } from '@components/DeviceContainer'
import DownloadAppBanner from '@features/intersection/article/DownloadAppBanner'
import ConvertKitEdm from '@components/ConvertKitEdm'

const MorePostContainer = styled.div`
  display: block;
`

const CommentsVirtualized = dynamic(() => import('./CommentsVirtualized'), { ssr: false })
const PopFbVideos = dynamic(() => import('./PopFbVideos'), { ssr: false })

const { publicRuntimeConfig } = getConfig()

// @refresh reset
class WebPost extends PureComponent<any, any> {
  static defaultProps = {
    isApp: false,
    post: initialState,
    t: () => '',
  }

  constructor(props) {
    super(props)
    this.state = {
      slogan: '',
    }
  }

  getPost = () => this.props.cleanPost

  getRandom = () => this.props.post.getIn(['post', 'random'])

  getRandomMore = () => this.props.post.getIn(['post', 'randomMore'])

  getSlogan = () => {
    const { t } = this.props
    const post = this.getPost()
    const sloganPrmName = post.clas[0] === 'beauty' ? 'sloganForBeauty' : 'slogan'
    const sloganLength: number = t(`${sloganPrmName}.length`) as any
    const sloganIndex = Math.floor(Math.random() * sloganLength)
    this.setState({ slogan: t(`${sloganPrmName}.${sloganIndex}`) })
  }

  componentDidMount() {
    this.bindClickToHashtags()
    this.getSlogan()
  }

  bindClickToHashtags = () => {
    const hashtags = document.querySelectorAll(`.${HASHTAG_CLASS_NAME}`)
    if (!hashtags) return
    for (const hashtag of hashtags) {
      hashtag.addEventListener('click', (event: MouseEvent) => {
        const url = (event.currentTarget as HTMLSpanElement).getAttribute('data-href')
        window.location.assign(url)
      })
    }
  }

  // 更多本作者文章、更多精選話題、其他同類型文章 (分類熱門文章排行榜上線後即可移除)
  renderMorePost() {
    const isSecret = isSecretOrSexClas(this.getPost().clas) // is Secret or Sex Post
    const random = this.getRandom()
    const randomMore = this.getRandomMore()

    return (
      <MorePostContainer>
        {!isSecret && random.size > 0 && <h2 className="authorPost">更多本作者貼文</h2>}
        {!isSecret &&
          random.size > 0 &&
          this.renderPostList({ postSection: 'sameAuthor', posts: random })}
        {randomMore.size > 0 && (
          <>
            <h2 className={isSecret ? 'section_otherClasPost' : 'section_moreTopicPost'}>
              {this.props.t(isSecret ? 'post:更多精選話題' : 'post:其他同類型文章')}
            </h2>
            {this.renderPostList({ postSection: 'sameTypeArticle', posts: randomMore })}
          </>
        )}
      </MorePostContainer>
    )
  }

  // 分類熱門文章排行榜
  renderPopularArticles() {
    const { isApp, isHideArticleSomeMessage } = this.props
    return (
      <PopularArticlesContext.Consumer>
        {(articles) =>
          !isHideArticleSomeMessage && (
            <PopularArticlesContainer articles={articles} isApp={isApp} />
          )
        }
      </PopularArticlesContext.Consumer>
    )
  }


  renderAside() {
    return (
      <aside className="aside">
        {/* header height 132 + margin offset 20 */}
        <Sticky top={152}>
          {publicRuntimeConfig.popularArticlesEnabled
            ? this.renderPopularArticles()
            : this.renderMorePost()}
        </Sticky>
      </aside>
    )
  }

  renderPostList = ({ posts, postSection }) => {
    if (posts.size === 0) return null

    return posts
      .toJS()
      .filter((article) => !article.clas.includes('ad'))
      .map((article) => (
        <ArticleCard
          key={article.postID}
          tagName="section"
          className="random-article popapp-post-con"
          article={article}
          postSection={postSection}
        />
      ))
  }


  renderContent = () => {
    const { cleanNoShaper: noShaper, cleanNodes, isApp } = this.props
    const { clas, postID } = this.getPost()
    const transform = transformFactory(noShaper, isApp, clas, postID)
    return cleanNodes.map(transform)
  }

  trackingSectionInfo = {
    section: TrackingSection.ARTICLE_INFO, // 【內文】頁【文章資訊】板塊
  }

  render() {
    const { t, isAdmin, userId, isApp, displayOptionMenu, optionType, isHideArticleSomeMessage } =
      this.props
    const post = this.getPost()

    const {
      postID = '',
      img = [],
      view = 0,
      secretColor = getSecretColor(),
      userInfo,
      editorType,
      publishedTime,
      clas,
    } = post
    const isAuthor = userId === userInfo?.mid
    const displayViews = isAdmin || isAuthor
    // no ID, no Post, no Content
    if (!postID) return null
    // post allow cover no img rules: hasClas(clas, ['secret', 'diary', 'love', 'employee']) || false
    // isWeb text replace
    const isForumPost = postID.includes('forum.')
    const {
      cleanTitle: postTitle,
      cleanDescription: postDescription,
      cleanNoShaper: noShaper,
    } = this.props

    const isSecret = isSecretOrSexClas(post.clas) // 匿名聊貼文
    const hasCoverImage = img[0] && img[0].path
    /**
     * 沒有首圖的匿名聊貼文
     * 才會顯示「背景純文字模式」
     */
    const isBackgroundTextPost = isSecret && !hasCoverImage

    const renderImageBlock = () => {
      if (hasCoverImage) {
        return (
          <PostImageBlock carousel={img} editorType={editorType} noShaper={noShaper}>
            <PostControlBox
              isApp={isApp}
              displayOptionMenu={displayOptionMenu}
              optionType={optionType}
            />
          </PostImageBlock>
        )
      }

      if (isBackgroundTextPost) {
        return (
          <PostImageBlock secretColor={secretColor} title={postTitle} text={postDescription}>
            <PostControlBox
              isApp={isApp}
              displayOptionMenu={displayOptionMenu}
              optionType={optionType}
            />
          </PostImageBlock>
        )
      }
    }

    return (
      <ArticleLayout className="article-container">
        <div className="toolbar" />
        <div className="article">
          <Article className="post-content">
            {postTitle && <H1>{postTitle}</H1>}
            {renderImageBlock()}
            {!isHideArticleSomeMessage && <ArticleUserInfo />}
            <div className="post">
              <StyledArticleContent className="content" itemProp="articleBody">
                {!isBackgroundTextPost && this.renderContent()}
              </StyledArticleContent>

              {/* Dable responsive ad widget */}
              <div
                dangerouslySetInnerHTML={{
                  __html: `
                    <div id="dablewidget_3703ZGKo_zlvm4bD7" data-widget_id-pc="3703ZGKo" data-widget_id-mo="zlvm4bD7">
                      <script>
                        (function(d,a,b,l,e,r) {
                          if(d[b]&&d[b].q)return;d[b]=function(){(d[b].q=d[b].q||[]).push(arguments)};e=a.createElement(l);
                          e.async=1;e.charset='utf-8';e.src='//static.dable.io/dist/plugin.min.js';
                          r=a.getElementsByTagName(l)[0];r.parentNode.insertBefore(e,r);
                        })(window,document,'dable','script');
                        dable('setService', 'popdaily.com.tw');
                        dable('sendLogOnce');
                        dable('renderWidgetByWidth', 'dablewidget_3703ZGKo_zlvm4bD7');
                      </script>
                    </div>
                  `,
                }}
              />

              {publicRuntimeConfig.articleTagsEnabled && (
                <div>
                  <ArticleTags />
                  {clas.includes('food') && !isForumPost && <ConvertKitEdm id="a4f0336e88" />}
                </div>
              )}
              <ArticleContentFooter className="post-bottom">
                <div>
                  <PopTime time={publishedTime} />
                </div>
                <div>{displayViews && view >= 0 && t('post:次觀看', { view })}</div>
              </ArticleContentFooter>
            </div>
            <ArticleAuthorInfo isHideArticleSomeMessage={isHideArticleSomeMessage} />
          </Article>
          {clas.includes('constellation') && !isForumPost && <ConvertKitEdm id="5c79d56a4f" />}
          {!isHideArticleSomeMessage && <CommentsVirtualized />}

          {!isApp && <PopFbVideos />}

          <RecommendedArticlesContext.Consumer>
            {(articles) => (
              <>
                <RecommendedArticles articles={articles} />
                {/* Only Showing FixedRecommendedArticleCard on mobile webview */}
                {!isApp && (
                  <MobileDisplayContainer>
                    {articles[0] && <FixedRecommendedArticleCard article={articles[0]} />}
                  </MobileDisplayContainer>
                )}
              </>
            )}
          </RecommendedArticlesContext.Consumer>

          {/* Mobile only */}
          {publicRuntimeConfig.popularArticlesEnabled && this.renderPopularArticles()}

        </div>
        {this.renderAside()}
        {publicRuntimeConfig.articleFixBottomAppDownloadBannerEnabled && !isApp && (
          <MobileDisplayContainer>
            <DownloadAppBannerContainer>
              <DownloadAppBanner
                isNeedCloseIcon={true}
                isArticlePage={true}
                slogan={this.state.slogan}
                buttonText={t(['openApp', '開啟 PopDaily App'])}
              />
            </DownloadAppBannerContainer>
          </MobileDisplayContainer>
        )}
      </ArticleLayout>
    )
  }
}

export default compose(
  withTranslation(['post']),
  getContext({ post: PropTypes.any.isRequired }),
  withCleanPostData('clean'),
)(WebPost)
